// Controla a aba ativa de uma página-hub via ?tab=X (mesma URL base).
// Deep-linkável e com histórico do navegador (voltar funciona). Whitelist:
// valor fora da lista cai no default. Generaliza o padrão de ClientTabs pra
// qualquer hub (Fiscal, CRM, Admin, etc).

import { useSearchParams } from 'react-router-dom';

export function useTabParam<T extends string>(
  ids: readonly T[],
  defaultId: T,
  paramKey = 'tab',
): { active: T; setActive: (id: T) => void } {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get(paramKey);
  const active: T = (ids as readonly string[]).includes(raw ?? '') ? (raw as T) : defaultId;

  function setActive(id: T): void {
    const next = new URLSearchParams(searchParams);
    next.set(paramKey, id);
    // replace:false → cada troca de aba entra no histórico (voltar volta pra aba anterior).
    setSearchParams(next, { replace: false });
  }

  return { active, setActive };
}
